import _ from "lodash";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {Header, Footer} from "@components";
import {Images, Svgs} from "@assets";
import {useNav} from "@hook";
import * as Datas from "@data";
import {api, constant, utils} from "@utils";

const printDivId = "print-modal";

export default function HomePage() {
  return (
    <div className="page">
      <Header />
      <div className={styles.container}>
        <div className={styles.section1}>
          <div className={styles.background}>
            <img src={Images.home_section1_bg} alt="bg" />
          </div>
          <div className={styles.content}>
            <div className={styles.subTitle}>
              리브 온 라이프 vs 주요 상조 3사 심층 비교 분석
            </div>
            <div className={styles.title}>
              <Svgs.HomeSection1Title />
            </div>
            <img
              className={styles.flowerImg}
              src={Images.home_flower}
              alt="image"
            />
            <div className={styles.desc}>
              가격의 거품을 걷어낸 합리적인 제안,
              <br />
              후회 없는 선택, 리브 온 라이프
            </div>
            <div className={styles.btn} onClick={constant.CS_CLICK}>
              <Svgs.HomeSection1ButtonBg />
              <span>24시간 상담 바로가기</span>
            </div>
            <div className={styles.boxList}>
              <div className={styles.box}>
                <div className={styles.boxTitle}>B,P,G 상조</div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>상품가격</div>
                  <div className={styles.rowData}>450 ~ 599만원</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>유골함</div>
                  <div className={styles.rowData}>일반 유골함(진공X)</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>의전 관리사</div>
                  <div className={styles.rowData}>4명</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>여성복</div>
                  <div className={styles.rowData}>5벌</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>수의 재질</div>
                  <div className={styles.rowData}>면수의 (저가형)</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>장식 서비스</div>
                  <div className={styles.rowData}>30~70만원</div>
                </div>
              </div>
              <div className={styles.box}>
                <div className={styles.boxTitle}>리브 온 라이프</div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>상품가격</div>
                  <div className={styles.rowData}>350만원</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>유골함</div>
                  <div className={styles.rowData}>명품 진공함</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>의전 관리사</div>
                  <div className={styles.rowData}>6명</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>여성복</div>
                  <div className={styles.rowData}>7벌</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>수의 재질</div>
                  <div className={styles.rowData}>대마수의 (고급형)</div>
                </div>
                <div className={styles.row}>
                  <div className={styles.rowTitle}>장식 서비스</div>
                  <div className={styles.rowData}>관 꽃장식 기본제공</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.section2}>
          <div className={styles.badge}>기본제공</div>
          <div className={styles.title}>
            아름다운 이별을 위한 헌정,
            <br />
            <span>관 꽃장식 기본 제공</span>
          </div>
          <div className={styles.subTitle}>
            일부 업체에서는 추가 비용이 발생하는 항목입니다.
            <br />
            리브 온 라이프는 마지막 길이 외롭지 않도록, 처음부터 정성을 담아
            기본에 포함합니다.
          </div>
          <img src={Images.home_img} alt="img" />
        </div>
        <div className={styles.section3}>
          <div className={styles.pc}>
            <Svgs.HomeSection3 />
          </div>
          <div className={styles.mobile}>
            <Svgs.HomeSection3Mobile />
          </div>
        </div>
        <div className={styles.section4}>
          <div className={styles.badge}>특별한 경험</div>
          <div className={styles.title}>
            슬픔에만 집중 할 수 있는
            <br />
            유가족을 위한 <span>세심한 배려</span>
          </div>
          <div className={styles.subTitle}>
            리브 온 라이프는 투명하고 정직한 장례로
            <br />
            합리적이지만 필수는 빠지지 않습니다.
          </div>
          <div className={styles.boxList}>
            <div className={styles.boxItem}>
              <Svgs.HomeSection4Icon1 />
              <div>
                명품 <span>진공함</span>(기본제공)
              </div>
              <div>
                습기와 해충으로부터 고인을
                <br />
                안전하게 영구 보존합니다.
              </div>
            </div>
            <div className={styles.boxItem}>
              <Svgs.HomeSection4Icon2 />
              <div>
                대마 <span>수의</span>(고급형)
              </div>
              <div>
                대형 상조사와 동일한
                <br />
                최고급 대마 수의를 제공합니다.
              </div>
            </div>
            <div className={styles.boxItem}>
              <Svgs.HomeSection4Icon3 />
              <div>
                여성복 <span>7벌</span>(업계 최다)
              </div>
              <div>
                현대 장례문화를 반영하여
                <br />
                넉넉하게 준비했습니다.
              </div>
            </div>
            <div className={styles.boxItem}>
              <Svgs.HomeSection4Icon4 />
              <div>
                의전 도우미 <span>6명</span>
              </div>
              <div>
                3일장 동안 힘든 조문 응대,
                <br />
                유가족의 부담을 덜어드립니다.
              </div>
            </div>
          </div>
          <div className={styles.bg}>
            <Svgs.HomeSection4Bottom />
          </div>
          <div className={styles.desc}>
            계약자가 아닌, 유가족 전체를 책임지는
            <br />
            리브 온 라이프의 약속
          </div>
          <div className={styles.btn} onClick={constant.CS_CLICK}>
            <Svgs.HomeSection1ButtonBg />
            <span>24시간 상담 바로가기</span>
          </div>
        </div>
        <div className={styles.section5}>
          <div className={styles.badge}>POINT 1</div>
          <div className={styles.title}>
            가격의 거품을 걷어낸
            <br />
            합리적인 제안
          </div>
          <div className={styles.subTitle}>
            대형 상조사와 비교해 부담은 낮추고,
            <br />
            실속형 상조사보다 더욱 합리적인 가격을 제안합니다.
          </div>
          <img src={Images.home_section5} alt="img" />
        </div>
        <div className={styles.imageSection}>
          <img src={Images.home_section_bg} alt="더 가벼운 선택, 리브온 250" />
          <div>
            <div>더 가벼운 선택, 리브온 250</div>
            <div>상황에 따라 더 간소한 장례를 원하시는 분들을 위한 플랜</div>
          </div>
        </div>
        <div className={styles.section6} id={constant.HOME_PRODUCT_DIV_ID}>
          <div className={styles.badge}>POINT 2</div>
          <div className={styles.title}>
            인력과 품질의 차이
            <br />
            한눈에 보는 구성
          </div>
          <div className={styles.subTitle}>
            대형 상조사와 비교해 부담은 낮추고,
            <br />
            실속형 상조사보다 더욱 합리적인 가격을 제안합니다.
          </div>
          <div className={styles.imgContainer}>
            <img src={Images.home_section6_1} alt="img" />
            <img src={Images.home_section6_2} alt="img" />
          </div>
        </div>
        <div className={styles.section7}>
          <div className={styles.badge}>실무 설계자</div>
          <div className={styles.title}>
            수많은 현장을 경험으로
            <br />
            리브 온 라이프를 시작했습니다.
          </div>
          <div className={styles.row}>
            <img src={Images.manager} alt="img" />
            <div>
              <div>리브 온 라이프 본부장</div>
              <table>
                <colgroup>
                  <col />
                  <col />
                </colgroup>
                <tbody>
                  <tr>
                    <td>2007년</td>
                    <td>보람 영업직 입사</td>
                  </tr>
                  <tr>
                    <td>2010년</td>
                    <td>KNN라이프</td>
                  </tr>
                  <tr>
                    <td>2012년</td>
                    <td>명인라이프</td>
                  </tr>
                  <tr>
                    <td>2015년</td>
                    <td>현대휘너럴</td>
                  </tr>
                  <tr>
                    <td>2017년</td>
                    <td>상조24시</td>
                  </tr>
                  <tr>
                    <td>2020년</td>
                    <td>광주으뜸상조 (후불제)</td>
                  </tr>
                  <tr>
                    <td>2021년</td>
                    <td>동두천 이담장례식장</td>
                  </tr>
                  <tr>
                    <td>2024년</td>
                    <td>리브온라이프 본부장</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
